export default __webpack_public_path__ + "static/media/loader_complete.60b0796c.svg";